<template>
    <div class="animated fadeIn">
        <b-row>
            <b-form-group label="Importuj zestawienie z banku" label-for="fileInputMulti" :label-cols="6">
                <b-form-file ref="documents" @change="uploadDocuments($event.target.name, $event.target.files); fileCount = $event.target.files.length" placeholder="Wybierz pliki" id="fileInputMulti" :multiple="true"></b-form-file>
            </b-form-group>
        </b-row>
        <b-row>
            <b-button @click="submitDocuments" type="button" size="sm" variant="primary">
                <i class="fa fa-dot-circle-o"></i> Importuj</b-button>
        </b-row>
    </div>
</template>

<script>
import Vue from 'vue'
import * as axios from 'axios';
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)

export default {
    
  data() {
    return {
      files: null
    };
  },
  methods: {
    uploadDocuments(name, files) {
        this.files = files
    },
    submitDocuments() {
        if (!this.files) {
            this.filesError()
            return
        }

        let formData = new FormData();

        for (let file of this.files) {
            formData.append('file', file);
        }

        axios.post(process.env.VUE_APP_API_URL + '/documents', formData).then(res => {
            this.showSuccessMsg()
        }).catch(err => {
            this.showError()
        })
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Sukces',
      message: 'Pomyślnie zaimportowano zestawienie.'
    },
    showError: {
      type: VueNotifications.types.error,
      title: 'Error',
      message: 'Nie udało się zaimportować zestawienia.'
    },
    filesError: {
      type: VueNotifications.types.error,
      title: 'Error',
      message: 'Wybierz pliki, które chcesz wczytać.'
    }
  }
};
</script>

<style>
</style>
